const apiUrls = {
  development: 'http://localhost:3000',
  staging: 'https://api-staging.goboon.co',
  production: 'https://api.goboon.co',
  demo: 'https://api-demo.goboon.co',
};

const environment = process.env.REACT_APP_ENVIRONMENT || 'development';
const baseServerUrl = apiUrls[environment];

export default baseServerUrl;
